<template>
  <transition>
    <div class="playback-container" id="fullScreen">
      <mainHeader></mainHeader>
      <div v-if="playBackUrl" class="video-wrap embed-responsive embed-responsive-16by9">
        <video id="video">
          <source :src="playBackUrl" type="video/mp4" />
        </video>
      </div>
      <div id="video-controls" class="controls" data-state="hidden">
        <div class="progress">
          <progress id="progress" value="0" min="0">
            <span id="progressBar"></span>
          </progress>
          <input @click="skipAhead($event)" class="seek" id="seek" value="0" min="0" type="range" step="1" />
        </div>
        <button @click="togglePlay()" class="ml-3" id="playpause" type="button" data-state="play">
          <i class="fa" :class="playPausedClass" aria-hidden="true"></i>
        </button>
        <button id="micClass" type="button" class="mr-3" @click="toggleSound()" data-state="micClass">
          <span v-if="micClass == 'fa-volume-up'" class="speaker-icon"></span>
          <span v-else class="speaker-off"></span>
        </button>
        <span class="time-controls"
          ><span id="time-elapse">{{ timeElapsed }}</span> / <span v-if="duration" id="duration">{{ duration }}</span></span
        >
      </div>
    </div>
  </transition>
</template>

<script>
import toastr from "toastr";
import mainHeader from "../common/main-header";
export default {
  name: "view-video",
  data() {
    return {
      videoEle: null,
      videoControls: null,
      playPausedClass: "fa-play",
      progressBar: null,
      progress: null,
      duration: "0:00",
      timeElapsed: "0:00",
      showModal: false,
      seek: null,
      micClass: "fa-volume-up",
      playBackUrl: null,
      isVideoLoading: false,
      archiveId: this.$route.params.archiveId,
      studyId: this.$route.params.studyId
    };
  },
  computed: {},
  components: { mainHeader },
  methods: {
    togglePlay() {
      if (this.videoEle.paused || this.videoEle.ended) {
        this.videoEle.play();
        this.changeBtnClass("fa-pause");
        const tDuration = Math.round(this.videoEle.duration);
        const time = this.formatTime(tDuration);
        this.duration = `${time.minutes}:${time.seconds}`;
      } else {
        this.videoEle.pause();
        this.changeBtnClass("fa-play");
      }
    },
    toggleSound() {
      this.videoEle.muted = !this.videoEle.muted;
      if (this.videoEle.muted) {
        this.micClass = "fa-volume-off";
      } else {
        this.micClass = "fa-volume-up";
      }
    },
    changeBtnClass(cssClass) {
      this.playPausedClass = cssClass;
    },
    updateTimeElapsed() {
      const time = this.formatTime(Math.round(this.videoEle.currentTime));
      this.timeElapsed = `${time.minutes}:${time.seconds}`;
    },
    initialiseTheVideo() {
      this.videoEle = document.getElementById("video");
      this.videoControls = document.getElementById("video-controls");
      this.progressBar = document.getElementById("progressBar");
      this.progress = document.getElementById("progress");
      this.progress.classList.add("progress-crome");
      this.seek = document.getElementById("seek");
    },
    formatTime(timeInSeconds) {
      const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
      return {
        minutes: result.substr(3, 2),
        seconds: result.substr(6, 2)
      };
    },
    downloadVideo() {
      toastr.warning("This feature is not enabled.");
      return;
    },
    updateModalState(value) {
      this.showModal = value;
    },
    skipAhead(event) {
      const skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value;
      this.videoEle.currentTime = skipTo;
      self.progressBar.value = skipTo;
      self.seek.value = skipTo;
    }
  },
  mounted() {
    const self = this;
    this.$api.getArchiveUrl(this.$route.params.studyId, this.$route.params.archiveId).then(response => {
      if (response.body) {
        this.playBackUrl = response.body;
        setTimeout(() => {
          this.initialiseTheVideo();
          this.videoEle.addEventListener("timeupdate", function() {
            self.progress.value = self.videoEle.currentTime;
            self.seek.setAttribute("max", self.videoEle.duration);
            self.seek.value = Math.floor(self.videoEle.currentTime);
            self.progressBar.style.width = Math.floor((self.videoEle.currentTime / self.videoEle.duration) * 100) + "%";
            self.progress.setAttribute("max", self.videoEle.duration);
            self.updateTimeElapsed();
            if (self.progress.value == self.videoEle.duration) {
              self.changeBtnClass("fa-play");
              self.videoEle.pause();
            }
          });
        }, 10);
      } else {
        toastr.error("Video is not available currently. Please try again later.");
      }
    });
  }
};
</script>

<style lang="scss" scoped>
#fullScreen {
  #video {
    height: 60%;
    top: 57px;
  }
  &.playback-container {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); /* Black background with opacity */
    .video-wrap {
      height: 65%;
      top: 23px;
    }
    #video-controls {
      position: absolute;
      height: 90px;
      background: #353b4a;
      opacity: 0.7;
      bottom: 0px;
      width: 100%;
      text-align: center;
      button {
        display: inline-block;
        background: transparent;
        border: none;
        margin: 0 auto;
        color: #fff;
        cursor: pointer;
        margin-right: 10px;
        &.close-panel {
          background: #fff;
        }
      }
      button:focus {
        outline: none;
      }
      .progress {
        position: relative;
        display: flex;
        overflow: hidden;
        font-size: 0.75rem;
        border-radius: none;
        background: transparent;
        margin-top: 13px;
        progress {
          width: 0%;
          margin: 0 auto;
          height: 0px;
        }
      }
    }
    .close-panel {
      width: 67px;
      border: 1px solid #fff;
      background: #fff;
      border-radius: 2px;
      i {
        color: #000;
      }
      span {
        padding-left: 4px;
        color: #4c8ce4;
      }
    }
    .inline-controls {
      display: inline-block;
      width: 132px;
      color: #fff;
      .download {
        display: inline-block;
        cursor: pointer;
      }
      #full-screen-icon {
        cursor: pointer;
        display: inline-block;
        margin-left: 10px;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .time-controls {
      color: #fff;
      margin-left: 8px;
    }
  }
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font: normal normal normal 40px/1 FontAwesome;
  line-height: 1;
  color: #1e8fe1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  position: absolute;
  left: 10px;
  cursor: pointer;
}
[dir="rtl"] .slick-prev {
  right: -25px;
  left: auto;
}
.slick-prev:before {
  content: "\f104";
  font-size: 36px;
}
.slick-next {
  position: absolute;
  right: 10px;
  cursor: pointer;
}
.slick-next:before {
  content: "\f105";
}
// common
.disabledCss {
  opacity: 0.4;
}
.loading-class {
  margin-top: 15%;
  margin-left: 50%;
}
.speaker-icon {
  background-image: url(/static/img/telehealth/speaker.png);
  width: 17px;
  height: 20px;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
  position: relative;
  top: 7px;
}
.speaker-off {
  background-image: url(/static/img/telehealth/mute-1.png);
  width: 17px;
  height: 20px;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
  position: relative;
  top: 7px;
}
</style>
<style scoped lang="scss" src="@/assets/range-slider.scss"></style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
